// extracted by mini-css-extract-plugin
module.exports = {"viewCheckout":"Index-Jtails_viewCheckout_2wa6y","infoBoxMobile":"Index-Jtails_infoBoxMobile_3CuIA","sectionStep":"Index-Jtails_sectionStep_2mMkY"};